/**
 * Forms
 *
 * @package Actinium
 * @since   1.0.0
 */

import $ from 'jquery';

/**
 * Make table attr from thead
 *
 * @since  1.0.0
 */
function tableDataAttr() {
	/**
	 * Run uniform on upload elements only.
	 */
	if ($('.wp-block-table:not( .pipelines )').length) {
		const tableLength = $('table:not( .pipelines )').length + 1;
		let i;

		for (i = 1; i < tableLength; i++) {
			// eslint-disable-next-line prefer-template
			$('.wp-block-table:not( .pipelines )').each(
				// eslint-disable-next-line no-loop-func
				function () {
					const tbody = $(this).children();
					const tr = tbody.children()[0];
					const $this = $(this);
					// $this.attr('data-tablesaw-mode', 'stack');
					// $this.addClass('tablesaw tablesaw-stack');

					$('<thead></thead>')
						.prependTo($this)
						.append(
							$('td', tr).map(
								(i, e) => $('<th>').html(e.textContent).get(0),
							),
						);
					const tbody2 = $(this).children();
					const tr2 = $(tbody2[1]).children();
					if (tr2.length && tr2.context.localName === 'tbody') {
						$(tr2[0]).remove();
					}
				},
			);
		}
	}
}

document.addEventListener('DOMContentLoaded', tableDataAttr);
